(async () => {

  if (!customElements.get('trustbuttons-slider-swiper')) {

    const Swiper = (await import('swiper')).default;
    const { Autoplay, Navigation, Pagination, Scrollbar } = await import('swiper/modules');

    // Modules are now included in the Swiper constructor options

    class TrustbuttonsSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-trustbuttons-slider]');
        this.swiperOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          threshold: 10,
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiperElement.update();
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener('shopify:block:select', (event) => {
            this.handleSectionEvents(event);
          });
        }
        this.init();
      }

      init() {
        this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleSectionEvents(event) {
        // Slide to slide based on the data attribute from the target and add 1 to get the slide index
        this.swiperElement.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
      }
    }

    window.TrustbuttonsSwiper = TrustbuttonsSwiper;

    customElements.define('trustbuttons-slider-swiper', TrustbuttonsSwiper);

  }

})();
